export default __webpack_public_path__ + "static/media/live-icon-active.536ee748.webp";